export default {
  tags: [],
  modules: [],
}
